var _path, _path2, _path3, _path4, _path5, _path6, _path7;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCoins(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.1429 13.1428V16.5714C21.1429 18.0571 17.5612 20 13.1429 20C8.7246 20 5.14288 18.0571 5.14288 16.5714V13.7143",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M21.1429 13.1428V16.5714C21.1429 18.0571 17.5612 20 13.1429 20C8.7246 20 5.14288 18.0571 5.14288 16.5714V13.7143",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.47888 14.0104C6.46745 15.3224 9.5246 16.5532 13.1429 16.5532C17.5612 16.5532 21.1429 14.7178 21.1429 13.1407C21.1429 12.2549 20.0149 11.2847 18.2446 10.6035",
    fill: "currentColor"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M5.47888 14.0104C6.46745 15.3224 9.5246 16.5532 13.1429 16.5532C17.5612 16.5532 21.1429 14.7178 21.1429 13.1407C21.1429 12.2549 20.0149 11.2847 18.2446 10.6035",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.7143 7.42847V10.857C17.7143 12.3428 14.1326 14.2856 9.71429 14.2856C5.29601 14.2856 1.71429 12.3428 1.71429 10.857V7.42847",
    fill: "currentColor"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M17.7143 7.42847V10.857C17.7143 12.3428 14.1326 14.2856 9.71429 14.2856C5.29601 14.2856 1.71429 12.3428 1.71429 10.857V7.42847",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.71429 10.8389C14.1326 10.8389 17.7143 9.00343 17.7143 7.42629C17.7143 5.848 14.1326 4 9.71429 4C5.29601 4 1.71429 5.848 1.71429 7.42629C1.71429 9.00343 5.29601 10.8389 9.71429 10.8389Z",
    fill: "currentColor",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCoins);
export default __webpack_public_path__ + "static/media/Coins.0590b4a47984b295dec2cde0d4306e69.svg";
export { ForwardRef as ReactComponent };